import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const multipleDocumentsMock: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EconomicSanctions$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EconomicSanctions',
        statusCode: ControllerStatus.ESCALATION_ACCEPTED,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2024-05-21T13:29:56.409Z',
          controlData: {
            sanctions: [
              {
                companyId: '113',
                sanctionId: '115250479-20230317135606274587',
                sanctionSource: {
                  originCode: 'Manual creation',
                  updateOriginCode: 'Manual creation',
                },
                sanctionTypeCode: 'SP',
                sanctionUpdateDateTime: '2023-03-17',
                sanctionCreationDate: '2023-03-17',
                isContinuatedSanction: true,
                sanctionEffectiveEndDate: '2025-03-17',
                isActive: true,
              },
            ],
            consecutiveSanctionsEndDate: '2025-03-17',
            rejectCode: 'ONGOING_SANCTION',
            escalationContact: 'roland.gasnier@eulerhermes.com',
          },
          responseDocumentIds: ['6b947463-c434-47f5-a714-3e74e233a886_pending'],
        },
        escalation: {
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          requestorId: 'CVE',
          responseDateTime: '2024-05-28T13:29:56.409Z',
          controlData: {
            companyId: '113',
            escalationResponse: {
              validator: 'johndoe',
              comment: 'OK.',
            },
            requestData: {},
          },
          requestDocumentIds: ['62b947463-c434-47f5-a714-3e74e233a886'],
          responseDocumentIds: ['62b947463-c434-47f5-a714-3e74e233a456'],
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/PoliticalExposedPerson$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'PoliticalExposedPerson',
        statusCode: ControllerStatus.CHECK_SUCCESS,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {},
          responseDocumentIds: [
            '6b947463-c434-47f5-a714-3e74e233a887_failed',
            '6b947463-c434-47f5-a714-3e74e233a889_deleted',
          ],
        },
      } satisfies ControllerDetails,
    },
  },
];
